import { render } from "./BuscarFotos.vue?vue&type=template&id=0413296e"
import script from "./BuscarFotos.vue?vue&type=script&lang=js"
export * from "./BuscarFotos.vue?vue&type=script&lang=js"

import exportComponent from "E:\\sistemas\\sinos_web\\sinos_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__